import PropTypes from 'prop-types';

export const massPropTypes = PropTypes.shape({
  id: PropTypes.string,
  massDate: PropTypes.string,
  availableMassOfferings: PropTypes.number,
  publicNote: PropTypes.string,
  hasUnlimitedOfferings: PropTypes.bool,
  allowFreeOfferings: PropTypes.bool,
  hasHour: PropTypes.bool,
  unavailableBecauseOfMinimumFromDate: PropTypes.bool,
  unavailableBecauseOfEvenDistribution: PropTypes.bool,
  providerParams: PropTypes.shape({
    providerId: PropTypes.string,
    slots: PropTypes.arrayOf(
      PropTypes.shape({
        primaryId: PropTypes.string,
        secondaryId: PropTypes.string,
        bookId: PropTypes.number,
      }),
    ),
  }),
});
